import { HEADER_TOGGLE_DROPDOWN, IToggleUserDropDown } from './types';

export function toggleUserDropDown(): IToggleUserDropDown {

  return {
    type: HEADER_TOGGLE_DROPDOWN,
  };

}
